export const gitCommit = '8efdc0f1'
